import React from 'react';
import {changeChain} from "./actions";
import {connect} from "react-redux";
import {CHAIN} from "../../constants";

class ChainToggle extends React.Component {
    render() {
        let id = 'radio-' + this.props.chain.description;

        return (
            <>
                <input
                    checked={this.props.isActive}
                    id={id}
                    type="radio"
                    name="Chain"
                    value={this.props.color}
                    onChange={(e) => this.props.onChange(this.props.chain)}
                />
                <label htmlFor={id} className="product__swatch">
                    {this.props.chain.description}
                </label>
            </>
        )
    }
}

class ChainSelector extends React.Component {
    render() {
        return (
            <div className='product__options'>
                <div className="product__length-option-name-container">
                    <h4 className="product__option-name">Chain</h4>
                    <a href="/pages/chain-guide" target="_blank">Chain guide</a>
                </div>

                <div className="product__swatch-container">
                    <ChainToggle isActive={this.props.selectedChain === CHAIN.CABLE} chain={CHAIN.CABLE} onChange={this.props.onChange}/>
                    <ChainToggle isActive={this.props.selectedChain === CHAIN.BUTCH} chain={CHAIN.BUTCH} onChange={this.props.onChange}/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        selectedChain: state.chain,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (chain) => {
            dispatch(changeChain(chain));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ChainSelector);
